module.exports = __webpack_public_path__ + "static/media/1080X1080 HOME-PLATILLOS-POSTRES_50.25f79dec.webp";